import { BaseService } from './BaseService';
import { PigletRegistrationDashboard } from '../models/piglet-registration';

/**
 * `GET /dashboard/piglets` exists in the backend's swagger as `DashboardsGetPigletRegistrationDashboard`,
 * but it is called through `BaseService` rather than the generated client: regenerating
 * `src/api/HealthSystemApi.ts` today also pulls in unrelated in-flight backend changes that break two
 * existing call sites. Sibling endpoints on this controller (`DashboardService`) are hand-written too, so
 * this stays consistent. Swap to `api.dashboards.dashboardsGetPigletRegistrationDashboard` once the client
 * is regenerated deliberately.
 */
export class PigletRegistrationService extends BaseService {
  url = '/dashboard/piglets';

  /**
   * `farmId` scopes the response to a farm other than the token's own business unit, for the admin farms
   * overview. Omitted - the farm user's own dashboard - the API answers for the signed-in business unit,
   * and `BuildQueryString` drops the empty parameter rather than sending `farmId=`.
   */
  getDashboard = async (weeks: number, farmId?: string): Promise<PigletRegistrationDashboard> => {
    const query = this.BuildQueryString({ weeks, farmId });
    const result = await this.Fetch(`${this.url}?${query}`, 'GET');
    return this.FromResult<PigletRegistrationDashboard>(result);
  };
}

export default PigletRegistrationService;
